// removed by extract-text-webpack-plugin
module.exports = {"sheetContainer":"_1vd65a-vw_A769L5cQzynb"};


//////////////////
// WEBPACK FOOTER
// ./src/views/datasheet/style.css
// module id = 926
// module chunks = 0